import bgi_anime from './bgi_anime';
import jump_to_another_page from './jump_to_another_page';
import spa from './spa';
import nav from './nav';
import sales from './sales';
import $ from 'jquery';


$(function(){
  new nav();
  new jump_to_another_page();
  new spa();
  new sales();
});




// WEBPACK FOOTER //
// ./dev/js/app.js